import { render, staticRenderFns } from "./VerticalNavMenuItem.vue?vue&type=template&id=1b3a56e3&"
import script from "./VerticalNavMenuItem.vue?vue&type=script&lang=ts&"
export * from "./VerticalNavMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports